import { render, staticRenderFns } from "./practiceDailyDoQuestion.vue?vue&type=template&id=2ac2aa27&scoped=true"
import script from "./practiceDailyDoQuestion.vue?vue&type=script&lang=js"
export * from "./practiceDailyDoQuestion.vue?vue&type=script&lang=js"
import style0 from "./practiceDailyDoQuestion.vue?vue&type=style&index=0&id=2ac2aa27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2aa27",
  null
  
)

export default component.exports